import { render, staticRenderFns } from "./ResultsSlide.vue?vue&type=template&id=3f85edb4&scoped=true"
import script from "./ResultsSlide.vue?vue&type=script&lang=js"
export * from "./ResultsSlide.vue?vue&type=script&lang=js"
import style0 from "./ResultsSlide.vue?vue&type=style&index=0&id=3f85edb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f85edb4",
  null
  
)

export default component.exports